import cn from 'classnames';

import Checkmark from 'components/icons/Checkmark.js';
import Tag from 'components/icons/Tag';
import { TEMPO } from 'context/BrandContext';
import useBrand from 'hooks/useBrand';

export const CHARCOAL_TAG = 'charcoal_tag';
export const BRAND_SPECIFIC_TAG = 'brand_specific_tag';
export const CUSTOM_TAG = 'custom_tag';

const APPLIED_TEXT = 'APPLIED';
const OFFER_TEXT = 'OFFER';

export const AppliedOrOfferTag = ({
  customTagStyles = null,
  isApplied = true,
  offerText = OFFER_TEXT,
  variation = CHARCOAL_TAG,
}) => {
  const isTempo = useBrand(TEMPO);
  const isCharcoalTag = variation === CHARCOAL_TAG;
  const isBrandSpecificTag = variation === BRAND_SPECIFIC_TAG;

  const iconProps = {
    className: cn(
      isApplied ? 'min-h-3 min-w-3' : 'h-3 w-3',
      isCharcoalTag && 'fill-cream-100',
      isBrandSpecificTag && (isTempo ? 'fill-tempo-blue-90' : 'fill-green-110')
    ),
    width: '12',
    height: '12',
    color: customTagStyles ? customTagStyles.textColor : '',
  };

  return (
    <div
      className={cn(
        'flex w-fit flex-row items-center gap-1 rounded px-1 py-0.5',
        isCharcoalTag && 'bg-charcoal-100',
        isBrandSpecificTag && (isTempo ? 'bg-tempo-blue-50' : 'bg-green-50')
      )}
      style={customTagStyles && { backgroundColor: customTagStyles.backgroundColor }}
    >
      {isApplied ? <Checkmark {...iconProps} /> : <Tag {...iconProps} />}
      <div
        className={cn(
          'h7',
          isCharcoalTag && 'text-cream-100',
          isBrandSpecificTag && (isTempo ? 'text-tempo-blue-90' : 'text-green-110')
        )}
        style={customTagStyles && { color: customTagStyles.textColor }}
      >
        {isApplied ? APPLIED_TEXT : offerText}
      </div>
    </div>
  );
};

AppliedOrOfferTag.propTypes = {
  customTagStyles: PropTypes.shape({
    backgroundColor: PropTypes.string,
    textColor: PropTypes.string,
  }),
  isApplied: PropTypes.bool,
  offerText: PropTypes.string,
  variation: PropTypes.string,
};

export default AppliedOrOfferTag;
